import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router';
import { LOGIN_URL } from '../../../const/routes';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonContainer from '../CommonContainer';

const renderRedirectToLogin = (location) => (
  <Redirect
    to={{
      pathname: LOGIN_URL,
      state: { from: location },
    }}
  />
);

const RestrictedRoute = (props) => {
  const { component: Component, path, exact, authenticated, userDataLoaded, ...rest } = props;
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    setIsLoading(authenticated && !userDataLoaded);
  }, [authenticated, userDataLoaded]);
  
  if (isLoading) {
    return (
      <CommonContainer vAlign="center">
        <CircularProgress />
      </CommonContainer>
    );
  }
  
  return (
    <Route
      path={path}
      exact={exact}
      render={({ location: { pathname } }) =>
        authenticated && userDataLoaded ? (
          <Component {...rest} />
        ) : (
          renderRedirectToLogin(pathname)
        )
      }
    />
  );
};
const decorate = compose(
  connect(
    store => ({
      authenticated: store.auth.authenticated,
      userDataLoaded: store.user.userDataLoaded,
    }),
    null,
  ),
);

export default decorate(RestrictedRoute);

